import {Translations} from './message.def';

export const en: Translations = {
  privacy: {
    title: 'Privacy Policy',
    acquisition: {
      title: '■ Information We Collect',

      text: 'In this app, the acquisition of user location and fitness activity information is necessary to enable the logging functionality.',
    },
    use: {
      title: '■ How We Use Your Information',
      text: 'This app utilizes the acquired user location and fitness activity information for the logging confirmation feature.',
    },
    disclosure: {
      title: '■ How We Share Your Information',
      text: "This app does not provide users' personal information to any third parties.",
    },
    tools: {
      title: '■ Third-Party Ads Providers',
      text: 'In this app, the advertisement delivery tool AppLovin (AppLovin Corporation) is used, and AppLovin may automatically collect user information. For the information collected, the purpose of use, and disclosure to third parties, please refer to the application privacy policy of the advertising delivery operator.\n(Note: This app is configured to not collect user information through AppLovin)',
    },
    contact: {
      title: '■ Contact Us',
      text: 'If you have any questions or concerns, please contact us at \ndev.logme@gmail.com.',
    },
  },
};
